// International school systems data for onboarding

export type SchoolLevel = {
  value: string;
  label: string;
  emoji: string;
  classes: { value: string; label: string }[];
};

export type SchoolSystem = {
  country: string;
  flag: string;
  code: string;
  levels: SchoolLevel[];
};

export const SCHOOL_SYSTEMS: SchoolSystem[] = [
  {
    country: "France",
    flag: "🇫🇷",
    code: "FR",
    levels: [
      {
        value: "primaire", label: "Primaire", emoji: "📖",
        classes: [
          { value: "cp", label: "CP" },
          { value: "ce1", label: "CE1" },
          { value: "ce2", label: "CE2" },
          { value: "cm1", label: "CM1" },
          { value: "cm2", label: "CM2" },
        ],
      },
      {
        value: "college", label: "Collège", emoji: "📚",
        classes: [
          { value: "6e", label: "6ème" },
          { value: "5e", label: "5ème" },
          { value: "4e", label: "4ème" },
          { value: "3e", label: "3ème" },
        ],
      },
      {
        value: "lycee", label: "Lycée", emoji: "🎒",
        classes: [
          { value: "seconde", label: "Seconde" },
          { value: "premiere", label: "Première" },
          { value: "terminale", label: "Terminale" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "licence", label: "Licence" },
          { value: "master", label: "Master" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
  {
    country: "États-Unis",
    flag: "🇺🇸",
    code: "US",
    levels: [
      {
        value: "elementary", label: "Elementary School", emoji: "🧒",
        classes: [
          { value: "kindergarten", label: "Kindergarten" },
          { value: "grade1", label: "1st Grade" },
          { value: "grade2", label: "2nd Grade" },
          { value: "grade3", label: "3rd Grade" },
          { value: "grade4", label: "4th Grade" },
          { value: "grade5", label: "5th Grade" },
        ],
      },
      {
        value: "middle", label: "Middle School", emoji: "📚",
        classes: [
          { value: "grade6", label: "6th Grade" },
          { value: "grade7", label: "7th Grade" },
          { value: "grade8", label: "8th Grade" },
        ],
      },
      {
        value: "high", label: "High School", emoji: "🎒",
        classes: [
          { value: "grade9", label: "9th Grade (Freshman)" },
          { value: "grade10", label: "10th Grade (Sophomore)" },
          { value: "grade11", label: "11th Grade (Junior)" },
          { value: "grade12", label: "12th Grade (Senior)" },
        ],
      },
      {
        value: "college", label: "College / University", emoji: "🎓",
        classes: [
          { value: "freshman", label: "Freshman" },
          { value: "sophomore", label: "Sophomore" },
          { value: "junior", label: "Junior" },
          { value: "senior", label: "Senior" },
          { value: "graduate", label: "Graduate" },
          { value: "phd", label: "PhD" },
        ],
      },
    ],
  },
  {
    country: "Royaume-Uni",
    flag: "🇬🇧",
    code: "UK",
    levels: [
      {
        value: "primary", label: "Primary School", emoji: "🧒",
        classes: [
          { value: "reception", label: "Reception" },
          { value: "year1", label: "Year 1" },
          { value: "year2", label: "Year 2" },
          { value: "year3", label: "Year 3" },
          { value: "year4", label: "Year 4" },
          { value: "year5", label: "Year 5" },
          { value: "year6", label: "Year 6" },
        ],
      },
      {
        value: "secondary", label: "Secondary School", emoji: "📚",
        classes: [
          { value: "year7", label: "Year 7" },
          { value: "year8", label: "Year 8" },
          { value: "year9", label: "Year 9" },
          { value: "year10", label: "Year 10 (GCSE)" },
          { value: "year11", label: "Year 11 (GCSE)" },
        ],
      },
      {
        value: "sixthform", label: "Sixth Form / College", emoji: "🎒",
        classes: [
          { value: "year12", label: "Year 12 (AS Level)" },
          { value: "year13", label: "Year 13 (A Level)" },
        ],
      },
      {
        value: "university", label: "University", emoji: "🎓",
        classes: [
          { value: "undergraduate", label: "Undergraduate" },
          { value: "masters", label: "Master's" },
          { value: "phd", label: "PhD" },
        ],
      },
    ],
  },
  {
    country: "Maroc",
    flag: "🇲🇦",
    code: "MA",
    levels: [
      {
        value: "prescolaire", label: "Préscolaire", emoji: "🧒",
        classes: [
          { value: "1ere_annee_pre", label: "1ère année" },
          { value: "2eme_annee_pre", label: "2ème année" },
        ],
      },
      {
        value: "primaire", label: "Primaire", emoji: "📖",
        classes: [
          { value: "1ap", label: "1ère année" },
          { value: "2ap", label: "2ème année" },
          { value: "3ap", label: "3ème année" },
          { value: "4ap", label: "4ème année" },
          { value: "5ap", label: "5ème année" },
          { value: "6ap", label: "6ème année" },
        ],
      },
      {
        value: "college", label: "Collège", emoji: "📚",
        classes: [
          { value: "1ac", label: "1ère année collège" },
          { value: "2ac", label: "2ème année collège" },
          { value: "3ac", label: "3ème année collège" },
        ],
      },
      {
        value: "lycee", label: "Lycée", emoji: "🎒",
        classes: [
          { value: "tronc_commun", label: "Tronc commun" },
          { value: "1bac", label: "1ère Bac" },
          { value: "2bac", label: "2ème Bac" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "licence", label: "Licence" },
          { value: "master", label: "Master" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
  {
    country: "Sénégal",
    flag: "🇸🇳",
    code: "SN",
    levels: [
      {
        value: "prescolaire", label: "Préscolaire", emoji: "🧒",
        classes: [
          { value: "petite_section", label: "Petite section" },
          { value: "moyenne_section", label: "Moyenne section" },
          { value: "grande_section", label: "Grande section" },
        ],
      },
      {
        value: "elementaire", label: "Élémentaire", emoji: "📖",
        classes: [
          { value: "ci", label: "CI" },
          { value: "cp", label: "CP" },
          { value: "ce1", label: "CE1" },
          { value: "ce2", label: "CE2" },
          { value: "cm1", label: "CM1" },
          { value: "cm2", label: "CM2" },
        ],
      },
      {
        value: "moyen", label: "Moyen", emoji: "📚",
        classes: [
          { value: "6e", label: "6ème" },
          { value: "5e", label: "5ème" },
          { value: "4e", label: "4ème" },
          { value: "3e", label: "3ème" },
        ],
      },
      {
        value: "secondaire", label: "Secondaire", emoji: "🎒",
        classes: [
          { value: "seconde", label: "Seconde" },
          { value: "premiere", label: "Première" },
          { value: "terminale", label: "Terminale" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "licence", label: "Licence" },
          { value: "master", label: "Master" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
  {
    country: "Côte d'Ivoire",
    flag: "🇨🇮",
    code: "CI",
    levels: [
      {
        value: "prescolaire", label: "Préscolaire", emoji: "🧒",
        classes: [
          { value: "petite_section", label: "Petite section" },
          { value: "moyenne_section", label: "Moyenne section" },
          { value: "grande_section", label: "Grande section" },
        ],
      },
      {
        value: "primaire", label: "Primaire", emoji: "📖",
        classes: [
          { value: "cp1", label: "CP1" },
          { value: "cp2", label: "CP2" },
          { value: "ce1", label: "CE1" },
          { value: "ce2", label: "CE2" },
          { value: "cm1", label: "CM1" },
          { value: "cm2", label: "CM2" },
        ],
      },
      {
        value: "college", label: "Collège", emoji: "📚",
        classes: [
          { value: "6e", label: "6ème" },
          { value: "5e", label: "5ème" },
          { value: "4e", label: "4ème" },
          { value: "3e", label: "3ème" },
        ],
      },
      {
        value: "lycee", label: "Lycée", emoji: "🎒",
        classes: [
          { value: "seconde", label: "Seconde" },
          { value: "premiere", label: "Première" },
          { value: "terminale", label: "Terminale" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "licence", label: "Licence" },
          { value: "master", label: "Master" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
  {
    country: "Belgique",
    flag: "🇧🇪",
    code: "BE",
    levels: [
      {
        value: "primaire", label: "Primaire", emoji: "📖",
        classes: [
          { value: "p1", label: "1ère primaire" },
          { value: "p2", label: "2ème primaire" },
          { value: "p3", label: "3ème primaire" },
          { value: "p4", label: "4ème primaire" },
          { value: "p5", label: "5ème primaire" },
          { value: "p6", label: "6ème primaire" },
        ],
      },
      {
        value: "secondaire", label: "Secondaire", emoji: "📚",
        classes: [
          { value: "s1", label: "1ère secondaire" },
          { value: "s2", label: "2ème secondaire" },
          { value: "s3", label: "3ème secondaire" },
          { value: "s4", label: "4ème secondaire" },
          { value: "s5", label: "5ème secondaire" },
          { value: "s6", label: "6ème secondaire" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "bachelier", label: "Bachelier" },
          { value: "master", label: "Master" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
  {
    country: "Canada",
    flag: "🇨🇦",
    code: "CA",
    levels: [
      {
        value: "prescolaire", label: "Préscolaire", emoji: "🧒",
        classes: [
          { value: "maternelle4", label: "Maternelle 4 ans" },
          { value: "maternelle5", label: "Maternelle 5 ans" },
        ],
      },
      {
        value: "primaire", label: "Primaire", emoji: "📖",
        classes: [
          { value: "1ere", label: "1ère année" },
          { value: "2eme", label: "2ème année" },
          { value: "3eme", label: "3ème année" },
          { value: "4eme", label: "4ème année" },
          { value: "5eme", label: "5ème année" },
          { value: "6eme", label: "6ème année" },
        ],
      },
      {
        value: "secondaire", label: "Secondaire", emoji: "📚",
        classes: [
          { value: "sec1", label: "Secondaire 1" },
          { value: "sec2", label: "Secondaire 2" },
          { value: "sec3", label: "Secondaire 3" },
          { value: "sec4", label: "Secondaire 4" },
          { value: "sec5", label: "Secondaire 5" },
        ],
      },
      {
        value: "cegep", label: "Cégep", emoji: "🎒",
        classes: [
          { value: "cegep1", label: "1ère année" },
          { value: "cegep2", label: "2ème année" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "baccalaureat", label: "Baccalauréat" },
          { value: "maitrise", label: "Maîtrise" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
  {
    country: "RD Congo",
    flag: "🇨🇩",
    code: "CD",
    levels: [
      {
        value: "primaire", label: "Primaire", emoji: "📖",
        classes: [
          { value: "1ere", label: "1ère année" },
          { value: "2eme", label: "2ème année" },
          { value: "3eme", label: "3ème année" },
          { value: "4eme", label: "4ème année" },
          { value: "5eme", label: "5ème année" },
          { value: "6eme", label: "6ème année" },
        ],
      },
      {
        value: "secondaire", label: "Secondaire", emoji: "📚",
        classes: [
          { value: "1ere_sec", label: "1ère secondaire" },
          { value: "2eme_sec", label: "2ème secondaire" },
          { value: "3eme_sec", label: "3ème secondaire" },
          { value: "4eme_sec", label: "4ème secondaire" },
          { value: "5eme_sec", label: "5ème secondaire" },
          { value: "6eme_sec", label: "6ème secondaire" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "licence", label: "Licence (Graduat)" },
          { value: "master", label: "Master" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
  {
    country: "Congo-Brazzaville",
    flag: "🇨🇬",
    code: "CG",
    levels: [
      {
        value: "prescolaire", label: "Préscolaire", emoji: "🧒",
        classes: [
          { value: "petite_section", label: "Petite section" },
          { value: "moyenne_section", label: "Moyenne section" },
          { value: "grande_section", label: "Grande section" },
        ],
      },
      {
        value: "primaire", label: "Primaire", emoji: "📖",
        classes: [
          { value: "cp1", label: "CP1" },
          { value: "cp2", label: "CP2" },
          { value: "ce1", label: "CE1" },
          { value: "ce2", label: "CE2" },
          { value: "cm1", label: "CM1" },
          { value: "cm2", label: "CM2" },
        ],
      },
      {
        value: "college", label: "Collège", emoji: "📚",
        classes: [
          { value: "6e", label: "6ème" },
          { value: "5e", label: "5ème" },
          { value: "4e", label: "4ème" },
          { value: "3e", label: "3ème" },
        ],
      },
      {
        value: "lycee", label: "Lycée", emoji: "🎒",
        classes: [
          { value: "seconde", label: "Seconde" },
          { value: "premiere", label: "Première" },
          { value: "terminale", label: "Terminale" },
        ],
      },
      {
        value: "universite", label: "Université", emoji: "🎓",
        classes: [
          { value: "licence", label: "Licence" },
          { value: "master", label: "Master" },
          { value: "doctorat", label: "Doctorat" },
        ],
      },
    ],
  },
];

export const SUBJECTS = [
  { value: "maths", label: "Maths", emoji: "📐" },
  { value: "francais", label: "Français", emoji: "📝" },
  { value: "anglais", label: "Anglais", emoji: "🇬🇧" },
  { value: "sciences", label: "Sciences", emoji: "🔬" },
  { value: "histoire", label: "Histoire-Géo", emoji: "🌍" },
  { value: "physique", label: "Physique-Chimie", emoji: "⚗️" },
  { value: "svt", label: "SVT / Biologie", emoji: "🌿" },
  { value: "philo", label: "Philosophie", emoji: "💭" },
  { value: "informatique", label: "Informatique", emoji: "💻" },
  { value: "economie", label: "Économie", emoji: "📊" },
  { value: "arabe", label: "Arabe", emoji: "🕌" },
  { value: "espagnol", label: "Espagnol", emoji: "🇪🇸" },
  { value: "ia", label: "Initiation à l'IA", emoji: "🤖" },
  { value: "eps", label: "EPS", emoji: "🏃" },
];

export const AVATARS = ["👦", "👧", "🧑", "👨‍🎓", "👩‍🎓", "🦊", "🐱", "🐶", "🦁", "🐼", "🦄", "🐸"];

// Map level to AI difficulty tier
export function getLevelTier(level: string): string {
  const primaire = ["primaire", "elementaire", "elementary", "primary", "maternelle", "prescolaire"];
  const college = ["college", "moyen", "middle", "secondary", "secondaire"];
  const lycee = ["lycee", "high", "sixthform", "cegep"];
  const universite = ["universite", "university", "college_us"];

  if (primaire.some((m) => level.includes(m))) return "primaire";
  if (college.some((m) => level.includes(m))) return "college";
  if (lycee.some((m) => level.includes(m))) return "lycee";
  if (universite.some((m) => level.includes(m))) return "universite";
  return "college";
}

// ─── Spécialités / options par niveau ───
// Chaque spécialité propose des matières recommandées (codes alignés sur SUBJECTS).
export type Specialty = {
  value: string;
  label: string;
  emoji: string;
  description: string;
  recommendedSubjects: string[];
};

export const LYCEE_SPECIALTIES: Specialty[] = [
  {
    value: "maths_physique", label: "Maths • Physique-Chimie", emoji: "🧮",
    description: "Sciences exactes, ingénierie, classes prépa scientifiques.",
    recommendedSubjects: ["maths", "physique", "informatique"],
  },
  {
    value: "svt_sciences", label: "SVT • Sciences", emoji: "🌿",
    description: "Médecine, biologie, environnement, géosciences.",
    recommendedSubjects: ["svt", "physique", "maths"],
  },
  {
    value: "nsi", label: "NSI • Numérique & Informatique", emoji: "💻",
    description: "Programmation, algorithmique, data, cybersécurité.",
    recommendedSubjects: ["informatique", "maths", "anglais"],
  },
  {
    value: "ses", label: "SES • Sciences Économiques & Sociales", emoji: "📊",
    description: "Économie, sociologie, sciences politiques, commerce.",
    recommendedSubjects: ["economie", "histoire", "maths"],
  },
  {
    value: "litteraire", label: "Littéraire • HLP", emoji: "📚",
    description: "Littérature, philosophie, langues, sciences humaines.",
    recommendedSubjects: ["francais", "philo", "anglais", "histoire"],
  },
  {
    value: "langues", label: "Langues & Cultures", emoji: "🌍",
    description: "LLCE, traduction, relations internationales.",
    recommendedSubjects: ["anglais", "espagnol", "arabe", "francais"],
  },
  {
    value: "arts", label: "Arts • Création", emoji: "🎨",
    description: "Arts plastiques, cinéma, musique, design.",
    recommendedSubjects: ["francais", "histoire", "philo"],
  },
  {
    value: "general_lycee", label: "Tronc commun (sans spécialité)", emoji: "📖",
    description: "Pas encore de spécialité choisie.",
    recommendedSubjects: ["maths", "francais", "anglais", "histoire"],
  },
];

export const UNIVERSITE_SPECIALTIES: Specialty[] = [
  {
    value: "info_data", label: "Informatique • Data • IA", emoji: "💻",
    description: "Dev, data science, intelligence artificielle, cybersécurité.",
    recommendedSubjects: ["informatique", "maths", "ia", "anglais"],
  },
  {
    value: "ingenierie", label: "Ingénierie • Sciences pour l'ingénieur", emoji: "⚙️",
    description: "Mécanique, électronique, génie civil, énergétique.",
    recommendedSubjects: ["maths", "physique", "informatique"],
  },
  {
    value: "math_physique", label: "Mathématiques • Physique", emoji: "📐",
    description: "Recherche fondamentale, prépa, enseignement.",
    recommendedSubjects: ["maths", "physique"],
  },
  {
    value: "medecine_sante", label: "Médecine • Santé", emoji: "🩺",
    description: "PASS/LAS, pharmacie, biologie médicale, soins.",
    recommendedSubjects: ["svt", "physique", "maths"],
  },
  {
    value: "bio_chimie", label: "Biologie • Chimie", emoji: "🧪",
    description: "Biotechnologies, écologie, biochimie.",
    recommendedSubjects: ["svt", "physique"],
  },
  {
    value: "eco_gestion", label: "Économie • Gestion • Commerce", emoji: "📈",
    description: "Management, finance, marketing, école de commerce.",
    recommendedSubjects: ["economie", "maths", "anglais"],
  },
  {
    value: "droit", label: "Droit • Sciences politiques", emoji: "⚖️",
    description: "Droit public/privé, science po, relations internationales.",
    recommendedSubjects: ["histoire", "francais", "philo"],
  },
  {
    value: "lettres_langues", label: "Lettres • Langues • LLCE", emoji: "📖",
    description: "Littérature, traduction, didactique des langues.",
    recommendedSubjects: ["francais", "anglais", "espagnol", "philo"],
  },
  {
    value: "shs", label: "Sciences humaines & sociales", emoji: "🧠",
    description: "Sociologie, psychologie, anthropologie, géographie.",
    recommendedSubjects: ["histoire", "philo", "francais"],
  },
  {
    value: "arts_design", label: "Arts • Design • Communication", emoji: "🎨",
    description: "Beaux-arts, design, audiovisuel, communication.",
    recommendedSubjects: ["francais", "anglais", "philo"],
  },
  {
    value: "autre_uni", label: "Autre / non décidé", emoji: "🌐",
    description: "Je préciserai plus tard.",
    recommendedSubjects: [],
  },
];

export function getSpecialtiesForLevel(level: string): Specialty[] {
  const tier = getLevelTier(level);
  if (tier === "lycee") return LYCEE_SPECIALTIES;
  if (tier === "universite") return UNIVERSITE_SPECIALTIES;
  return [];
}
